export const volquetesConstants = {
  GET_VOLQUETES: 'GET_VOLQUETES',
  GET_AVAILABLE_VOLQUETES: 'GET_AVAILABLE_VOLQUETES',
  GET_VOLQUETES_OBSERVATIONS: 'GET_VOLQUETES_OBSERVATIONS',
}
